var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-demo"}},[_c('loading-default'),_c('loading-type'),_c('loading-color'),_c('loading-background'),_c('loading-contained')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }